import React from "react";
import "./AnimatedDownloadIcon.scss";

interface AnimatedDownloadIconProps {
  size?: number;
  alt?: string;
  style?: React.CSSProperties;
  className?: string;
}

const AnimatedDownloadIcon: React.FC<AnimatedDownloadIconProps> = ({
  size = 16,
  alt = "Downloading",
  style,
  className = "",
}) => {
  const mergedClassName = ["animated-download-icon", className].filter(Boolean).join(" ");

  return (
    <span className={mergedClassName} style={{ width: size, height: size, ...style }}>
      <span className="animated-download-icon__mover">
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          className="animated-download-icon__glyph"
          role="img"
          aria-label={alt}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path className="animated-download-icon__arrow animated-download-icon__arrow--narrow" d="M10 7L12 9L14 7" />
          <path className="animated-download-icon__arrow animated-download-icon__arrow--wide" d="M8.5 10L12 13.5L15.5 10" />
          <path className="animated-download-icon__arrow animated-download-icon__arrow--wider" d="M7 13.5L12 18.5L17 13.5" />
        </svg>
      </span>
    </span>
  );
};

export default AnimatedDownloadIcon;
